// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RatingsUI_view__x8Mso {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.RatingsUI_loader__MYOyQ {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.RatingsUI_input__qWgXk {
  background-color: #fbfbfb;
  border-color: #d2d2d2;
  border-radius: 4px;
  margin-right: 20px;
}

.RatingsUI_select__nmsKu {
  width: 200px;
}

.RatingsUI_search__yqBi5 {
  width: 120px;
}

.RatingsUI_newQuestion__Hy8k9{
  width: 180px;
}

.RatingsUI_header__HLs3q {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.RatingsUI_titleWrap__MywtR span {
  display: block;
}

.RatingsUI_label__13Am6 {
  font-weight: 500;
  color: var(--gray);
}

.RatingsUI_title__\\+AIhE {
  font-weight: 700;
  font-size: 24px;
  font-family: BebasNeue;
}

.RatingsUI_bodyRatings__tjsiu {
  margin-top: 40px;
}

.RatingsUI_scores__S0Uzn {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}

.RatingsUI_scoreWrap__Gx3lF {
  margin-right: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 500;
}

.RatingsUI_score__UVRCr {
  margin-bottom: 10px;
  color: var(--orange);
  font-size: 32px;
}

.RatingsUI_scoreLabel__JJBoc {
  color: #404040;
  font-size: 12px;
}

.RatingsUI_star__nysC9 {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}

.RatingsUI_actions__fj7nd{
  display: flex;
}

.RatingsUI_divider__DjuY7{
  width: 1px;
  background-color: #c9c9c9;
  height: 22px;
  margin: 0 15px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/ratings/styles/RatingsUI.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AACA;EACE,YAAY;AACd;;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".view {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.input {\n  background-color: #fbfbfb;\n  border-color: #d2d2d2;\n  border-radius: 4px;\n  margin-right: 20px;\n}\n\n.select {\n  width: 200px;\n}\n\n.search {\n  width: 120px;\n}\n.newQuestion{\n  width: 180px;\n}\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.titleWrap span {\n  display: block;\n}\n\n.label {\n  font-weight: 500;\n  color: var(--gray);\n}\n\n.title {\n  font-weight: 700;\n  font-size: 24px;\n  font-family: BebasNeue;\n}\n\n.bodyRatings {\n  margin-top: 40px;\n}\n\n.scores {\n  display: flex;\n  align-items: center;\n  margin-bottom: 40px;\n}\n\n.scoreWrap {\n  margin-right: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-weight: 500;\n}\n\n.score {\n  margin-bottom: 10px;\n  color: var(--orange);\n  font-size: 32px;\n}\n\n.scoreLabel {\n  color: #404040;\n  font-size: 12px;\n}\n\n.star {\n  width: 15px;\n  height: 15px;\n  margin-right: 5px;\n}\n\n.actions{\n  display: flex;\n}\n\n.divider{\n  width: 1px;\n  background-color: #c9c9c9;\n  height: 22px;\n  margin: 0 15px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `RatingsUI_view__x8Mso`,
	"loader": `RatingsUI_loader__MYOyQ`,
	"input": `RatingsUI_input__qWgXk`,
	"select": `RatingsUI_select__nmsKu`,
	"search": `RatingsUI_search__yqBi5`,
	"newQuestion": `RatingsUI_newQuestion__Hy8k9`,
	"header": `RatingsUI_header__HLs3q`,
	"titleWrap": `RatingsUI_titleWrap__MywtR`,
	"label": `RatingsUI_label__13Am6`,
	"title": `RatingsUI_title__+AIhE`,
	"bodyRatings": `RatingsUI_bodyRatings__tjsiu`,
	"scores": `RatingsUI_scores__S0Uzn`,
	"scoreWrap": `RatingsUI_scoreWrap__Gx3lF`,
	"score": `RatingsUI_score__UVRCr`,
	"scoreLabel": `RatingsUI_scoreLabel__JJBoc`,
	"star": `RatingsUI_star__nysC9`,
	"actions": `RatingsUI_actions__fj7nd`,
	"divider": `RatingsUI_divider__DjuY7`
};
export default ___CSS_LOADER_EXPORT___;
